import Markdown from "react-markdown";

type Props = {
  title: string;
  subtitle?: string;
  content?: string;
};

export const Topics = ({ title, subtitle, content }: Props) => {
  return (
    <section className="mb-16">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 bg-primary-light rounded-tr-[35px] rounded-bl-[35px] px-6 py-4 mb-6">
          <h2 className="text-white font-bold text-2xl md:whitespace-nowrap">
            {title}
          </h2>
          <div className="hidden md:block w-px h-12 bg-white flex-shrink-0" />
          <p className="text-white md:text-base leading-relaxed">{subtitle}</p>
        </div>
        <Markdown
          components={{
            li: ({ children, ...rest }) => (
              <li className="flex items-start gap-3 mb-6" {...rest}>
                <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                <span className="flex-1">{children}</span>
              </li>
            ),
            ul: ({ children, ...rest }) => (
              <ul className="list-none" {...rest}>
                {children}
              </ul>
            ),
          }}
        >
          {content}
        </Markdown>
      </div>
    </section>
  );
};
